import { Switch } from "@/components/ui/switch";
import { MODULES } from "@/lib/staff";

// cap: optional max permissions (for KAPTEN); disabled: read-only
export const PermissionMatrix = ({ value, onChange, cap, disabled, testidPrefix = "perm" }) => {
  const set = (key, field, on) => {
    const cur = value[key] || { view: false, manage: false };
    let next = { ...cur, [field]: on };
    if (field === "manage" && on) next.view = true;
    if (field === "view" && !on) next.manage = false;
    onChange({ ...value, [key]: next });
  };
  const allowed = (key, field) => !cap || cap[key]?.[field];

  return (
    <div className="overflow-hidden rounded-xl border border-white/10" data-testid={`${testidPrefix}-matrix`}>
      <div className="grid grid-cols-[1fr_80px_80px] bg-[#13131a] px-4 py-2.5 text-[10px] font-semibold uppercase tracking-widest text-zinc-500">
        <span>Menu</span>
        <span className="text-center">Lihat</span>
        <span className="text-center">Kelola</span>
      </div>
      {MODULES.map((m) => {
        const v = value[m.key] || { view: false, manage: false };
        return (
          <div key={m.key} className="grid grid-cols-[1fr_80px_80px] items-center border-t border-white/5 px-4 py-3">
            <div>
              <div className="text-sm font-medium text-white">{m.label}</div>
              <div className="text-[11px] text-zinc-500">
                {v.manage ? "Boleh lihat, tambah, ubah & hapus" : v.view ? "Hanya boleh melihat" : "Menu disembunyikan & diblokir"}
              </div>
            </div>
            {["view", "manage"].map((field) => (
              <div key={field} className="flex justify-center">
                <Switch
                  checked={v[field]}
                  disabled={disabled || (!v[field] && !allowed(m.key, field))}
                  onCheckedChange={(on) => set(m.key, field, on)}
                  data-testid={`${testidPrefix}-${m.key}-${field}`}
                />
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
};
